import { render, staticRenderFns } from "./SipSettings.vue?vue&type=template&id=65e6b612&scoped=true"
import script from "./SipSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./SipSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SipSettings.vue?vue&type=style&index=0&id=65e6b612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e6b612",
  null
  
)

export default component.exports